module.exports = __webpack_public_path__ + "img/txt.a7de4936.png";